import { MyBiographies } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const MyBiographiesServices = {
  MyBiographiesData: async ({ type, queryParams }) => {
    try {
      const payload = {
        ...MyBiographies?.getBiographyData(type),
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  deleteMyBiography: async (id) => {
    try {
      const payload = {
        ...MyBiographies?.deleteMyBiography(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  deleteSendBiography: async (id) => {
    try {
      const payload = {
        ...MyBiographies?.deleteSendBiography(id),
      };

      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  deleteMemorialUser: async (id) => {
    try {
      const payload = {
        ...MyBiographies?.deleteUser(id),
      };

      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  homeBiographiesData: async ({queryParams}) => {
    try {
      const payload = {
        ...MyBiographies?.getHomeBiographyData,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  biographyPublish: async (id) => {
    try {
      const payload = {
        ...MyBiographies?.updatePublishNow(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  LatestBiographyData: async (queryParams) => {
    try {
      const payload = {
        ...MyBiographies?.getLatestData,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  countBiography: async () => {
    try {
      const payload = {
        ...MyBiographies?.getbiographyCountData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
